export type QuestionTitlePropsType = {
  questionNumber: number;
  questionCount: number;
};

function QuestionTitle({ questionNumber, questionCount }: QuestionTitlePropsType) {
  return (
    <p className=' text-lg font-medium'>
      <span>سوال </span>
      {questionNumber}
      <span> از </span>
      {questionCount}
      <span>:</span>
    </p>
  );
}

export default QuestionTitle;
